module.exports = __webpack_public_path__ + "img/weixin@3x.966c96b1.png";